import React, { Component } from 'react';
import API from './API';
import ResourceField from './ResourceField';
import ValidationMessage from '../ValidationMessage';

export default class StaticResourceField extends Component {
  state = {
    isLoading: false,
    options: []
  };

  constructor(props) {
    super(props);

    this.definition = props.definitions[props.name];

    if (!ResourceField.cache[this.props.name]) {
      ResourceField.cache[this.props.name] = {};
    }

    this.loadAllOptions();
  }

  loadAllOptions() {
    this.setState({ isLoading: true });
    const params = '?' + (this.definition.resource.query || '');
    new API()
      .fetch(
        'autocomplete/' + this.definition.resource.name + '.json' + params,
        'GET',
        undefined,
        'application/json',
        { public: this.definition.resource.public }
      )
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          isLoading: false,
          options: this.getOptions(data)
        });
      })
      .catch(() => {
        this.setState({
          isLoading: false,
          options: []
        });
      });
  }

  getOptions(data) {
    return data.map((resource) => ({
      identifier: resource[this.definition.resource.identifier],
      name: this.definition.resource.value(resource)
    }));
  }

  onChange(event) {
    const value = event.target.value;
    if (value && this.state.options.length > 0) {
      const selectedOption = this.state.options.find(opt => opt.identifier === value);
      if (selectedOption) {
        ResourceField.cache[this.props.name][value] = selectedOption.name;
      }
    }
    this.props.setFieldValue(this.props.name, value);
  }

  render() {
    const hasError = this.props.errors[this.props.name] && this.props.touched[this.props.name];
    const currentValue = this.props.values[this.props.name] || '';

    return (
      <div className={`form-group dropdown ${this.props.className}`}>
        <label htmlFor={this.props.name}>{this.definition.title}</label>
        <select
          id={this.definition.resource.name}
          name={this.props.name}
          className={`form-control ${hasError ? 'is-invalid' : ''}`}
          value={currentValue}
          onChange={this.onChange.bind(this)}
          autoFocus={this.props.autoFocus}
          disabled={this.state.isLoading}
        >
          <option value="">Kies een optie...</option>
          {this.state.options.map((option) => (
            <option key={option.identifier} value={option.identifier}>
              {option.name}
            </option>
          ))}
        </select>
        {hasError && <ValidationMessage>{this.props.errors[this.props.name]}</ValidationMessage>}
      </div>
    );
  }
}
